




import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import UCWebsiteBanner from '@shared/components/@organisms/UCWebsiteBanner/UCWebsiteBanner.vue';
import useBrandConfig from '@shared/composables/useBrandConfig';

import { transformWebsiteBannerSlide } from './helpers';
import { ISBWebsiteBannerStory } from './types';

export default defineComponent({
  name: 'StoryblokWebsiteBanner',
  components: { UCWebsiteBanner },
  props: {
    slides: {
      type: Array as PropType<ISBWebsiteBannerStory[]>,
      default: () => [],
    },
    categoryPrefix: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const { componentConfig } = useBrandConfig();
    const config = componentConfig.StoryblokWebsiteBanner;
    const transformedSlides = computed(() =>
      props.slides.map(transformWebsiteBannerSlide(config.categoryPrefix ?? 'parts')),
    );

    return {
      transformedSlides,
    };
  },
});
